import Task from '../models/Task';
import Topic from '../../settings/models/Topic';

export interface CommonState {
  tasks: Task[];
  topics: Topic[];
}

export const commonState: CommonState = {
  tasks: [],
  topics: [],
};
